(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["customer-type"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('customer-type')) {
    const companyKeys = ['Organisasjonsnummer', 'Firmanavn', 'Firmaadresse', 'Postnummer', 'Poststed'];
    const state = { attributes: null, queue: Promise.resolve(), timer: null };
    const instances = () => document.querySelectorAll('customer-type');
    function persist() {
      clearTimeout(state.timer);
      state.timer = null;
      const attributes = { ...state.attributes };
      state.queue = state.queue.catch(() => {}).then(async () => {
        const response = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes })
        });
        if (!response.ok) throw new Error('Cart update failed');
      });
      state.queue.catch(() => instances().forEach(element => element.status(element.dataset.saveError)));
    }
    function sync() { instances().forEach(element => element.render()); }
    class CustomerType extends HTMLElement {
      connectedCallback() {
        if (!state.attributes) {
          state.attributes = { Kundetype: this.querySelector('[data-customer-kind]:checked').value };
        }
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.addEventListener('change', event => {
          if (event.target.matches('[data-customer-kind]')) {
            state.attributes.Kundetype = event.target.value;
            companyKeys.forEach(key => state.attributes[key] = '');
            sync(); persist();
          }
        }, options);
        this.render();
      }
      disconnectedCallback() { this.controller?.abort(); }
      status(message) { this.querySelector('[data-company-status]').textContent = message; }
      render() {
        if (!state.attributes) return;
        document.documentElement.dataset.customerKind = state.attributes.Kundetype;
        const business = state.attributes.Kundetype === 'Bedrift';
        this.querySelectorAll('[data-customer-kind]').forEach(input => input.checked = input.value === state.attributes.Kundetype);
        const note = this.querySelector('[data-business-checkout-note]');
        if (note) note.hidden = !business;
      }
    }
    customElements.define('customer-type', CustomerType);
  }
  } catch(e) { console.error(e); }
})();

})();
